import 'whatwg-fetch'; // fetch polyfill
import {
	loopFocus,
	gaEvent,
	loopAriaHidden,
} from '../../js/utils';

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["onSubmit"] }] */
class Form {
	constructor(form) {
		this.form = form;
		this.formEl = form.querySelector('form');
		this.id = this.form.getAttribute('data-form-id');
		this.formOpenClass = 'c-form--open';
		this.formErrorClass = 'c-form--error';
		this.formSuccessClass = 'c-form--success';
		this.formFieldClass = 'c-form__input';
		this.formFieldErrorClass = 'c-form__input--error';
		this.formFieldSuccessClass = 'c-form__input--valid';
		this.formCloseButtonClass = '.c-form__close-button';
		this.formSubmitButton = this.form.querySelector('.c-form__submit');
		this.formCompletionButton = this.form.querySelector('.c-form__complete-close');
		this.onSubmit = this.onSubmit.bind(this);
		this.handleInvalid = this.handleInvalid.bind(this);
		this.handleValid = this.handleValid.bind(this);
		this.open = this.open.bind(this);
		this.close = this.close.bind(this);
		this.init = this.init.bind(this);
		this.lastElementOnFocus = '';
	}

	init() {
		const openButtons = document.querySelectorAll(`button[data-form-id="${this.id}"], a[data-form-id="${this.id}"]`);
		const inputs = this.form.querySelectorAll('input, select, textarea');
		this.closeButton = this.form.querySelector(this.formCloseButtonClass);

		if (this.formEl) {
			this.formEl.addEventListener('submit', this.onSubmit);
		} else if (this.form) {
			this.form.addEventListener('submit', this.onSubmit);
		}

		if (this.closeButton) {
			this.closeButton.addEventListener('click', this.close);
		}

		if (this.formCompletionButton) {
			this.formCompletionButton.addEventListener('click', this.close);
		}

		if (openButtons.length > 0) {
			openButtons.forEach((button) => {
				button.addEventListener('click', this.open);
			});
		}

		if (inputs.length > 0) {
			for (const input of inputs) {
				const isValid = () => (
					input.checkValidity()
						? this.handleValid(input)
						: this.handleInvalid(input)
				);
				input.addEventListener('invalid', () => this.handleInvalid(input), false);
				input.addEventListener('valid', () => this.handleValid(input), false);
				input.addEventListener('keyup', () => isValid(), false);
				input.addEventListener('blur', () => isValid(), false);

				if (input.type === 'checkbox') {
					const inputLabel = input.parentNode;
					if (inputLabel) {
						const toggleCheckbox = () => {
							const isChecked = inputLabel.getAttribute('aria-checked') === 'true';
							inputLabel.setAttribute('aria-checked', !isChecked);
							input.checked = !isChecked;
						};

						inputLabel.onkeypress = (event) => {
							const isEnterOrSpace = event.keyCode === 32 || event.keyCode === 13;

							if (isEnterOrSpace) {
								toggleCheckbox();
							}
						};
					}
				}
			}
		}
	}

	handleInvalid(element) {
		element.classList.remove(this.formFieldSuccessClass);
		element.classList.add(this.formFieldErrorClass);
	}

	handleValid(element) {
		element.classList.remove(this.formFieldErrorClass);
		element.classList.add(this.formFieldSuccessClass);
	}

	open(event) {
		event.preventDefault(); // prevent navigation if open button is an anchor tag

		if (this.form) {
			this.lastElementOnFocus = document.activeElement;
			this.form.classList.add(this.formOpenClass);
			this.form.setAttribute('role', 'dialog');
			this.form.setAttribute('aria-modal', true);
			loopAriaHidden({
				value: false,
				element: '.c-form--open',
			});

			// // Focus to first field when open
			// this.form.querySelector(`.${this.formFieldClass}`).focus();

			loopFocus({
				el: this.form,
				FOCUSABLE_ELEMENT_SELECTORS: '.c-form--open input:not([type="hidden"]), .c-form--open button, .c-form--open label, .c-form--open select, .c-form--open textarea, .c-form--open a[href]',
			});
		}

		if (!document.body.classList.contains('c-body--mobile')) {
			document.body.classList.add('c-body--active');
		}
	}

	close() {
		if (this.form) {
			this.form.removeAttribute('role');
			this.form.removeAttribute('aria-modal');
			loopAriaHidden({
				value: true,
				element: '.c-form--open',
			});
			this.form.classList.remove(this.formOpenClass);
			this.lastElementOnFocus.focus();
		}

		document.body.classList.remove('c-body--active');
	}

	onSubmit() {
		let formNameValue = 'Contact form';
		let formEventValue = '';
		if (this.formSubmissionButton) {
			this.formSubmitButton.setAttribute('disabled', true);
		}

		const formNameField = this.formEl.querySelector('input[name="formName"]');
		const formEventField = this.formEl.querySelector('input[name="formEvent"]');

		if (formNameField != null) {
			formNameValue = formNameField.value;
		}

		if (formEventField != null) {
			formEventValue = formEventField.value;
		}

		gaEvent({
			event: 'formSubmission',
			eventCategory: 'Forms',
			eventAction: 'Successful submission',
			eventLabel: formNameValue,
			form_type: formEventValue,
		});
	}
}

export default Form;
